

























































































import Vue from 'vue';
import { SparkWebDAO, WebComment } from '@/web';
import ago from 's-ago';
import autosize from 'autosize';
import firebase, { auth } from 'firebase/app';
import { Comment, CommentQueryResult, DefaultPhotos, LinkPreview } from 'sparkello-core';
import { linkPreview } from '@/firebaseConfig';
import UrlRegex from 'url-regex';
import LinkPreviewWidget from '@/vue-components/util/LinkPreviewWidget.vue';
import { LinkPreviewWebDAO } from '@/web/dao/linkPreview/LinkPreviewWebDAO';
import { UserWebDAO } from '@/web/dao/user/UserWebDAO';

declare interface SparkCommentData {
  newComment: string;
  subscribedComments: WebComment[];
  oldComments: WebComment[];
  moreCommentsToLoad: boolean;
  lastQueryResult: CommentQueryResult | undefined;
  linkPreviewResponseCounter: number;
  showLinkPreview: boolean;
  linkPreview: LinkPreview | undefined;
  commentsHasLink: boolean;
  userCanComment: boolean;
}

export default Vue.extend({
  name: 'SparkComments',
  props: {
    sparkId: String,
  },
  components: {
    LinkPreviewWidget,
  },
  data(): SparkCommentData {
    return {
      newComment: '',
      subscribedComments: [],
      oldComments: [],
      moreCommentsToLoad: false,
      lastQueryResult: undefined,
      linkPreviewResponseCounter: 0,
      showLinkPreview: false,
      linkPreview: undefined,
      commentsHasLink: false,
      userCanComment: false,
    };
  },
  computed: {
    comments: {
      get(): WebComment[] {
        return this.subscribedComments.concat(this.oldComments);
      },
    },
    profilePhotoUrl(): string {
      return firebase.auth().currentUser?.photoURL ||
        DefaultPhotos.getDefaultProfilePhotoForName(firebase.auth()?.currentUser?.displayName || undefined);
    },
  },
  created() {
    //Get user permissions to determine if they can comment
    this.getUserPermissions();

    //Fetch the old comments, specifying a cache read first
    this.fetchOldComments('default');

    //Establish a subscription to new spark comments if a user is logged in
    if (this.$store.state.currentUser) {
      SparkWebDAO.getInstance().subscribeToSparkComments(this.sparkId, comments => {
        this.fetchLinkPreviews(comments);
        this.subscribedComments = comments;
        console.log('Subscribed comments', comments);
      });
    }
  },
  mounted() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  updated() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  destroyed() {
    SparkWebDAO.getInstance().unsubscribeFromSparkComments();
  },
  methods: {
    ago(date: Date): string {
      return date ? ago(date || new Date()) : '...';
    },
    login() {
      sessionStorage.setItem('redirectPath', this.$router.currentRoute.path);
      this.$router.push('/login');
    },
    signup() {
      sessionStorage.setItem('redirectPath', this.$router.currentRoute.path);
      this.$router.push('/signup');
    },
    fetchLinkPreviews(comments: WebComment[]) {
      comments.forEach((comment) => {
        this.getLinkPreview(comment);
      });
    },
    getLinkPreview(comment: WebComment) {
      if (comment.linkPreviewId) {
        //Get the linkPreview info
        LinkPreviewWebDAO.instance.getLinkPreview(comment.linkPreviewId).then((linkPreview) => {
          console.log('Got link preview data', linkPreview);
          comment.linkPreview = linkPreview;
          this.$forceUpdate();
        }).catch(e => {
          console.log('Could not get LinkPreview for id', comment.linkPreviewId, e);
        });
      }
    },
    keydownInputHandler(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        event.preventDefault(); //Prevents the new line from being submited
        this.postComment();
      }
    },
    keyupInputHandler(event) {
      // const urlRegEx = /(https?:\/\/[^\s]+)/g;
      const urlRegEx = UrlRegex({ strict: false });
      // console.log(urlRegEx.source);

      if (this.newComment.match(urlRegEx)) {
        this.linkPreviewResponseCounter++;
        if (this.linkPreviewResponseCounter === 1) {
          console.log('showlinkpreview');
          const matchedUrls: string[] | null = this.newComment.match(urlRegEx);
          if (matchedUrls) {
            this.generateLinkPreview(matchedUrls[0]);
          }
        }
      }
    },
    generateLinkPreview(url: string) {
      linkPreview({ url })
        .then((response) => {
          console.log('link preview response', response.data);
          this.linkPreview = response.data;
          this.showLinkPreview = true;

        }).catch(reason => {
        console.log('Error loading link preview: ', reason);
        this.linkPreviewResponseCounter = 0;
      });
    },
    postComment() {
      console.log('Post comment', this.newComment);

      const text: string = this.newComment?.trim();
      this.newComment = '';

      const linkPreview = this.linkPreview;

      if (text || linkPreview) {
        const comment = { parentId: this.sparkId, text: text } as WebComment;
        comment.authorUid = this.$store.state.currentUser.uid;
        comment.authorName = this.$store.state.currentUser.displayName;
        comment.authorProfileImage = this.$store.state.currentUser.photoURL;
        comment.linkPreviewId = linkPreview?.id;
        comment.linkPreview = linkPreview;

        SparkWebDAO.getInstance().setSparkComment(comment).then(comment => {
          console.log('Success posting comment', comment);

          //Force the textarea to resize after the comment is cleared.
          const commentBox = document.getElementById('new-comment') as HTMLTextAreaElement;
          commentBox.value = '';
          autosize.update(document.querySelectorAll('textarea'));
        });

        if (this.showLinkPreview) {
          this.clearLinkPreview();
        }
      }
    },
    fetchOldComments(source: 'server' | 'cache' | 'default' = 'default') {
      const maxItems = this.lastQueryResult ? 10 : 20;
      console.log('Last item is', this.lastQueryResult?.paginationLastItemRef);
      SparkWebDAO.getInstance()
        .getSparkComments(this.sparkId,
          maxItems,
          this.lastQueryResult?.paginationLastItemRef,
          source)
        .then((result: CommentQueryResult) => {

          if (source == 'cache' && result.comments.length == 0) {
            console.log('Got nothing from the cache');
            this.fetchOldComments('server');
          } else {
            this.fetchLinkPreviews(result.comments);
            this.oldComments = this.oldComments.concat(result.comments);
            this.lastQueryResult = result;
            this.moreCommentsToLoad = (source == 'cache' || ['server', 'default'].includes(source) && result.comments.length == maxItems);
          }
          console.log('Comment Results', result.comments);
          console.log('Old Comments List', this.oldComments);
          console.log('More comments to load?', this.moreCommentsToLoad, ', Source:', source, ', Result length:', result.comments.length, ', Max Items:', maxItems);

        }).catch(error => {
        console.log('Error retrieving comments', error);
      });
    },
    clearLinkPreview() {
      this.linkPreviewResponseCounter = 0;
      this.showLinkPreview = false;
      this.linkPreview = undefined;
    },
    getUserPermissions() {
      console.log('Getting user permissions');
      UserWebDAO.instance.getCurrentUserPermissions().then((result) => {
        console.log('User permissions', result);
        this.userCanComment = result?.sparkCommentModerator || false;
      }).catch(e => {
        console.error('Could not get user permissions', e);
      });

    },
    showCommentOptions(comment: Comment) {
      return auth()?.currentUser?.uid == comment.authorUid;
    },
    deleteComment(comment: Comment) {
      if (window.confirm('Are you sure you want to delete this comment?')) {
        SparkWebDAO.getInstance().deleteSparkComment(comment).then(() => {
          console.log(this.comments);
          let index = this.subscribedComments.findIndex(element => element.id == comment.id);
          console.log('Index is ', index);
          if (index >= 0) {
            this.subscribedComments.splice(index, 1);
          } else {
            index = this.oldComments.findIndex(element => element.id == comment.id);
            console.log('Index is ', index);
            if (index >= 0) {
              this.oldComments.splice(index, 1);
            }
          }
          this.$forceUpdate();
        });
      }
    },
  },
})
;
